import { render } from "./DeclineVerificationModal.vue?vue&type=template&id=f7852a2c"
import script from "./DeclineVerificationModal.vue?vue&type=script&lang=js"
export * from "./DeclineVerificationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__